import { useEffect, useState } from 'react';

const PORTRAIT_MEDIA_QUERY = '(orientation: portrait)';

export default (enabled: boolean) => {
    const [isPortrait, setIsPortrait] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        if (!enabled) {
            setIsPortrait(undefined);
            return;
        }

        const mediaQueryList = window.matchMedia(PORTRAIT_MEDIA_QUERY);
        const handleChange = (ev: MediaQueryListEvent) => setIsPortrait(ev.matches);

        setIsPortrait(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', handleChange);

        return () => mediaQueryList.removeEventListener('change', handleChange);
    }, [enabled]);

    return isPortrait;
};
